import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';

import { Provider } from 'react-redux';
import { ErrorBoundary, Loader } from './components';
import { theme } from './layouts';
import AppRouter from './routes/AppRouter';
import Snackbar from './utils/Snackbar';
import store from './store';
import RoleManager from './components/RoleManager/RoleManager';
import { GrowthContextProvider } from './modules/GrowthReport/GrowthContext';
import { FinancialYearProvider } from './modules/Eligibility/FinancialYearContext';

const App = () => (
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <CssBaseline />
        <RoleManager />
        <Router>
          <ErrorBoundary>
            <Suspense fallback={<Loader />}>
              <FinancialYearProvider>
                <GrowthContextProvider>
                  <AppRouter />
                  <Snackbar />
                </GrowthContextProvider>
              </FinancialYearProvider>
            </Suspense>
          </ErrorBoundary>
        </Router>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

export default App;
